/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import dayjs from 'dayjs';
import { InstitutionType } from 'app/shared/model/enumerations/institution-type.model';

export interface IInstitution {
  id?: string;
  institutionCode?: string | null;
  name?: string | null;
  code?: string | null;
  address?: string | null;
  fax?: string | null;
  email?: string | null;
  contactEmail?: string | null;
  phone?: string | null;
  mobile?: string | null;
  web?: string | null;
  chequePrintingName?: string | null;
  institutionType?: keyof typeof InstitutionType | null;
  pointOfIssueNo?: string | null;
  descreption?: string | null;
  inactive?: boolean | null;
  active?: boolean | null;
  microSec?: dayjs.Dayjs | null;
  timestampEntry?: dayjs.Dayjs | null;
  lastUpdated?: dayjs.Dayjs | null;
  cursor?: number;
  institution?: IInstitution | null;
}

export const defaultValue: Readonly<IInstitution> = {
  inactive: false,
  active: false,
};
